import { TinyColor } from '@ctrl/tinycolor';
export const getRicosShadeCssVars = (backgroundColor, textColor) => {
    const toRgb = (color) => new TinyColor(/^\s*\d/.test(color) ? `rgb(${color})` : color).toRgb();
    const background = toRgb(backgroundColor);
    const text = toRgb(textColor);
    // Match Wixel's calculateShades: mix the text into the background in RGB space.
    const mix = (textRatio) => ['r', 'g', 'b']
        .map((channel) => Math.round(textRatio * text[channel] + (1 - textRatio) * background[channel]))
        .join(',');
    return {
        ricosShade1: mix(0.1),
        ricosShade2: mix(0.3),
        ricosShade3: mix(0.5),
    };
};
//# sourceMappingURL=ricos-theme-shades.js.map